<template>
  <v-container class="pa-0">
    <template v-if="scoreOnly">
      <div class="d-flex align-center">
        <v-progress-linear
          color="info"
          background-color="blue lighten-5"
          style="border-radius: 20px !important"
          :value="round(score * 100)"
          height="12"
          rounded
        ></v-progress-linear>
        <span class="text-caption ml-2 font-weight-medium"
          >{{ round(score * 100) || 0 }}%</span
        >
      </div>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="4" class="text-center">
          <v-progress-circular
            :rotate="-90"
            :size="70"
            :width="6"
            :value="round(occupancyTwoWeeks * 100)"
            color="primary darken-1"
          >
            <span class="text-caption font-weight-medium black--text">{{
              isNaN(round(occupancyTwoWeeks * 100))
                ? 'N/A'
                : `${round(occupancyTwoWeeks * 100)}%`
            }}</span>
          </v-progress-circular>
          <p class="mb-0 mt-1">
            <span
              class="text-caption grey--text text--darken-2 font-weight-medium"
              >{{ $t('Next 14 days') }}</span
            >
          </p>
        </v-col>
        <v-col cols="4" class="text-center">
          <v-progress-circular
            :rotate="-90"
            :size="70"
            :width="6"
            :value="round(occupancyMonth * 100)"
            color="primary darken-1"
          >
            <span class="font-weight-medium text-caption black--text">{{
              isNaN(round(occupancyMonth * 100))
                ? 'N/A'
                : `${round(occupancyMonth * 100)}%`
            }}</span>
          </v-progress-circular>
          <p class="mb-0 mt-1">
            <span
              class="text-caption grey--text text--darken-2 font-weight-medium"
              >{{ $t('Next 30 days') }}</span
            >
          </p>
        </v-col>
        <v-col cols="4" class="text-center">
          <v-progress-circular
            :rotate="-90"
            :size="70"
            :width="6"
            :value="round(occupancyThreeMonth * 100)"
            color="primary darken-1"
          >
            <span class="text-caption font-weight-medium black--text">{{
              isNaN(round(occupancyThreeMonth * 100))
                ? 'N/A'
                : `${round(occupancyThreeMonth * 100)}%`
            }}</span>
          </v-progress-circular>
          <p class="mb-0 mt-1">
            <span
              class="text-caption grey--text text--darken-2 font-weight-medium"
              >{{ $t('Next 90 days') }}</span
            >
          </p>
        </v-col>
      </v-row>
      <v-divider v-if="!hideScore"></v-divider>
      <div v-if="!hideScore">
        <div class="d-flex align-center mt-2 mb-1">
          <span
            class="text-body-2 grey--text text--darken-2 font-weight-medium"
            >{{ $t('Health') }}</span
          >
        </div>
        <div class="d-flex align-center">
          <v-progress-linear
            color="info"
            background-color="blue lighten-5"
            style="border-radius: 20px !important"
            :value="round(score * 100)"
            height="12"
            rounded
          ></v-progress-linear>
          <span class="text-caption ml-2 font-weight-medium"
            >{{ round(score * 100) || 0 }}%</span
          >
        </div>
        <div
          v-if="backScore"
          class="health-text bt-1 mt-1"
          :class="backScoreClass"
        >
          {{ round(backScore * 100) }}%
        </div>
      </div>
    </template>
  </v-container>
</template>

<script>
import round from 'lodash/round'

export default {
  props: [
    'score',
    'occupancyTwoWeeks',
    'occupancyMonth',
    'occupancyThreeMonth',
    'occupancyTwoWeeksBack',
    'occupancyMonthBack',
    'occupancyThreeMonthBack',
    'listing',
    'hideScore',
    'scoreOnly',
  ],
  computed: {
    backScore() {
      if (
        this.occupancyThreeMonthBack &&
        this.occupancyMonthBack &&
        this.occupancyTwoWeeksBack
      ) {
        return (
          (this.occupancyThreeMonthBack +
            this.occupancyMonthBack +
            this.occupancyTwoWeeksBack) /
          3
        )
      }
      return 0
    },
    backScoreClass() {
      if (this.backScore) {
        if (this.backScore > 0.8) {
          return 'green-health'
        } else if (this.backScore > 0.6) {
          return 'yellow-health'
        }
      }
      return 'red-health'
    },
    scoreClass: function () {
      if (this.score > 0.8) {
        return 'green-health'
      } else if (this.score > 0.6) {
        return 'yellow-health'
      } else {
        return 'red-health'
      }
    },
  },
  methods: {
    round: function (input) {
      return round(input, 1)
    },
  },
}
</script>
